import type { NodeTypes } from '@xyflow/react';
import { TriggerNode } from './TriggerNode';
import { ConditionNode } from './ConditionNode';
import { ActionNode } from './ActionNode';
import { AINode } from './AINode';
import { EndNode } from './EndNode';

export const workflowNodeTypes: NodeTypes = {
  trigger: TriggerNode,
  condition: ConditionNode,
  action: ActionNode,
  ai: AINode,
  end: EndNode,
};

export { TriggerNode, ConditionNode, ActionNode, AINode, EndNode };
